<div [formGroup]="form">
  <div [formGroupName]="type">

    <ng-container *ngIf="question">
      <div class="question-label-container" [ngClass]="displayFieldCss(type+'.'+(parentQuestion ? parentQuestion.id+'-'+question.id : question.id))">
        <mat-label class="question-label h3">{{ question.label }}</mat-label>
      </div>
      <ng-container *ngFor="let answer of question.answers">
        <mat-form-field *ngIf="answer.inputType === 'text'" class="form-field form-full-width-field">
          <mat-label [innerHTML]="'$common_description' | translate"></mat-label>
          <input matInput type="text"
                [value]="answer.text || ''"
                placeholder="Description"
                (input)="onKeyPress($event.target.value, null, question.id, answer)"
                [disabled]="readOnly" />
        </mat-form-field>
      </ng-container>
    </ng-container>
  </div>
</div>
